import $api from "../../../axios"
import { apiAmazonChanges, apiCampaigns } from "../../../constants/targetsApi.constants"
import { IDateRange } from "../../../types/filter"

const getHistory = (dateRange: IDateRange) => {
  return $api.post(`${apiCampaigns + apiAmazonChanges}/getHistory`, { dateRange })
}

export default {
  getHistory,
}
